import React from 'react';

import {
  FormControl,
  FormControlLabel,
  Box,
  FormHelperText,
  Switch,
} from '@mui/material';

export default function InteractiveDisabledField({
  value,
  setValue,
  setChanged,
}) {
  return (
    <Box>
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Switch
              checked={value}
              onChange={() => {
                setChanged();
                setValue(!value);
              }}
            />
          }
          label='Disable Interactive Jobs'
        />
        <FormHelperText id='interactive-disabled-helper-text'>
          Disable job types that provide interactive access (Notebooks) for the
          project.
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
